import LocationType from "./LocationType";
export default LocationType;